import { PageProps } from 'gatsby'
import React, { useState } from 'react'

import type { PageNodeType, SingleTypeComponentType } from '@application/Types/ComponentTypes'
import type { Locale } from '@application/Types/Locale'
import { Seo } from '@src/Application/Interfaces/Features/Seo'
import { StrapiTranslations, Translations } from '@src/Application/Types/TranslationTypes'
import { Context } from '@src/Infrastructure/Context'
import { OrganizationProvider } from '@src/Infrastructure/Context/OrganizationContext'
import { getTranslations } from '@src/templates/utils'

export const Head = (
    props: PageProps<
        { strapiPage: PageNodeType; strapiTranslation?: StrapiTranslations },
        {
            id: string
            language: Locale
            singleTypeComponents?: SingleTypeComponentType
        }
    >
) => {
    const {
        pageContext: { language },
        location,
        data: { strapiPage: pageData, strapiTranslation },
    } = props

    const {
        metaDescription,
        metaFollow,
        metaIndex,
        metaTitle,
        schemaPrimaryImageOfPageUrl,
        alternateUrls,
        schemaMarkup,
        pageComponents,
    } = pageData

    const [sendMixpanelEvents, setSendMixpanelEvents] = useState(false)

    const translations: Translations = getTranslations(strapiTranslation as StrapiTranslations)

    return (
        <Context.Provider
            value={{
                locale: language,
                translations,
                sendMixpanelEvents,
                setSendMixpanelEvents,
            }}
        >
            <OrganizationProvider>
                <Seo
                    location={location}
                    title={metaTitle}
                    description={metaDescription}
                    isNoFollow={metaFollow === 'nofollow'}
                    isNoIndex={metaIndex === 'noindex'}
                    lang={language}
                    schemaPrimaryImageOfPageUrl={schemaPrimaryImageOfPageUrl}
                    alternateUrls={alternateUrls}
                    schemaMarkup={schemaMarkup}
                    pageComponents={pageComponents}
                />
            </OrganizationProvider>
        </Context.Provider>
    )
}
